/*
 * Conditionally display layout areas
 */

import $ from 'jquery';
export default function() {
    $(function() {
        $('.js-check-content').each(function() {
            var $check = $('.js-check-me-for-content .sfContentBlock', this);
            var $checkContainers = $('.js-check-me-for-content .sf_colsIn', this);
            var $plainCheck = $('.js-check-me-for-content', this);
            var $checkmvc = $('.js-check-me-for-content .mg-maxx-events', this);
            if ($check.children().length) {
                $(this).removeClass('hidden');
            }
            if ($plainCheck.children().length) {
                $(this).removeClass('hidden');
            }
            if ($checkmvc.children().length) {
                $(this).removeClass('hidden');
            }
            if ($checkContainers.children().length) {
                $(this).removeClass('hidden');
            }
        });
    });
}


// WEBPACK FOOTER //
// ./src/js/partials/content-check.js